import { Address } from '@app/domain/model/Address';
import { ViolationError } from '@app/lib/form/contracts/ViolationError';
import { isNonEmpty } from '@app/lib/util/isNonEmpty';

export function validateAddress(address: Address | null): ViolationError | null {
    if (!address) return { message: 'profile.validation.addressRequired' };

    const { country, city, streetAddress, street, houseNumber, postalCode } = address;

    if (!isNonEmpty(country)) {
        return { message: 'profile.validation.fieldRequired' };
    }
    if (!isNonEmpty(city)) {
        return { message: 'profile.validation.fieldRequired' };
    }

    const hasFull = isNonEmpty(streetAddress);
    const hasParts = isNonEmpty(street) && isNonEmpty(houseNumber);
    if (!hasFull && !hasParts) {
        return { message: 'profile.validation.fieldRequired' };
    }

    if (!isNonEmpty(postalCode)) {
        return { message: 'profile.validation.fieldRequired' };
    }

    return null;
}
